module.exports = __webpack_public_path__ + "static/img/icon1@2x.d565bc2f.png";